import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/redux/utils'

export interface Wallet {
  id: string
  logo: string
  name: string
}

export const readAllWallets = 'readAllWallets'

export const walletSlice = createApi({
  reducerPath: 'wallet',
  baseQuery,
  tagTypes: [readAllWallets],
  endpoints: builder => ({
    readAllWallets: builder.query<Wallet[], void>({
      query: () => '/wallet/all',
      providesTags: [readAllWallets],
    }),
  }),
})

export const {
  useReadAllWalletsQuery,
  useLazyReadAllWalletsQuery,
} = walletSlice
